import { getDataFromServer } from '../../../util';

export class RiskLevelChangeListModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  fetchRiskLevelChangeList = async (payload) => {
    const params = {
      metaName: 'risklevelchange'
    };

    const url = `${this.baseURL}/meta`;
    const data = await getDataFromServer(url, this.httpHeaders, params);
    if (Array.isArray(data) && data.length > 0) {
      return data.map((riskLevelChange) => ({
        label: riskLevelChange,
        value: riskLevelChange
      }));
    }

    return [];
  };
}
